module.exports = __webpack_public_path__ + "media/images/comportamento-074a98f4b3e785b4b0a2d385ddb8391a.svg";